import React from "react";

interface IProps {
  isShowLogout: boolean;
  setIsShowLogout: () => void;
}

const ModalConfirmLogout: React.FC<IProps> = ({
  isShowLogout,
  setIsShowLogout,
}) => {
  const Cookies = require("js-cookie");

  return (
    <div className={`model-group ${isShowLogout ? "active" : ""} `}>
      {isShowLogout && (
        <div className="modal-overlay" onClick={setIsShowLogout}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            
            {/* Title XÁC NHẬN */}
            <div className="modal-title">
              XÁC NHẬN
            </div>
            
            {/* Text thủ thuật */}
            <div className="modal-text">
              Bạn có chắc muốn đăng xuất không?
            </div>
            
            {/* Buttons accept và cancel */}
            <div className="modal-buttons">
              <img 
                src="/assets/btn-accept.png" 
                alt="Accept" 
                className="modal-button accept-button"
                onClick={() => {
                  Cookies.remove("access_token");
                  setIsShowLogout();
                  window.location.reload();
                  localStorage.removeItem("user_info");
                }}
              />
              <img 
                src="/assets/btn-cancel.png" 
                alt="Cancel" 
                className="modal-button cancel-button"
                onClick={setIsShowLogout}
              />
            </div>
          </div>
        </div>
      )}
      <style
        dangerouslySetInnerHTML={{
          __html: `
/* Modal Styles - Copy from CongThucPage.css */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background-image: linear-gradient(rgba(12, 52, 95, 0.28), rgba(12, 52, 95, 0.28)), url('/assets/bg-frame.png');
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
  border: 2px solid rgba(83, 136, 186, 0.55);
  border-radius: 20px;
  padding: 40px;
  text-align: center;
  max-width: 500px;
  width: 90%;
  box-shadow: 0 0 30px rgba(6, 27, 49, 0.55), inset 0 0 18px rgba(255, 255, 255, 0.08);
}

.modal-icon {
  margin-bottom: 20px;
}

.question-icon {
  width: 120px;
  height: 120px;
  display: block;
  margin: 0 auto;
}

.modal-title {
  color: white;
  font-size: 32px;
  font-weight: bold;
  margin-bottom: 20px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
}

.modal-text {
  color: #ffffff;
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 30px;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
}

.modal-buttons {
  display: flex;
  justify-content: center;
  gap: 20px;
}

.modal-button {
  width: 166px;
  cursor: pointer;
  transition: transform 0.3s ease;
  object-fit: contain;
}

.modal-button:hover {
  transform: scale(1.1);
}

/* Responsive Modal */
@media (max-width: 768px) {
  .modal-content {
    /* Force background frame to fill container on mobile */
    background: linear-gradient(rgba(12, 52, 95, 0.28), rgba(12, 52, 95, 0.28)), url('/assets/bg-frame.png') !important;
    background-size: 100% 100% !important;
    background-position: center !important;
    background-repeat: no-repeat !important;
    padding: 30px;
    max-width: 400px;
  }
  
  .question-icon {
    width: 100px;
    height: 100px;
  }
  
  .modal-title {
    font-size: 28px;
  }
  
  .modal-text {
    font-size: 20px;
  }
  
  .modal-button {
    width: 100px;
    height: 100px;
    object-fit: contain;
  }
}

@media (max-width: 480px) {
  .modal-content {
    padding: 20px;
    max-width: 350px;
  }
  
  .question-icon {
    width: 80px;
    height: 80px;
  }
  
  .modal-title {
    font-size: 24px;
  }
  
  .modal-text {
    font-size: 18px;
  }
  
  .modal-button {
    width: 80px;
    height: 80px;
    object-fit: contain;
  }
}
`,
        }}
      />
    </div>
  );
};

export default ModalConfirmLogout;
